import { Directive, ElementRef, inject } from '@angular/core';

@Directive({
  selector: '[tvdDropdownAnchor]',
  exportAs: 'tvdDropdownAnchor',
})
export class DropdownAnchorDirective {
  readonly nativeElement: HTMLElement = inject(ElementRef).nativeElement;
}
